<template>
  <div>
    <el-card>
      <div slot="header">
        <span>上传配置</span>
      </div>
      
      <el-form :model="form" label-width="140px" style="max-width: 800px;">
        <el-form-item label="上传方式">
          <el-radio-group v-model="form.type">
            <el-radio label="local">本地存储</el-radio>
            <el-radio label="oss">阿里云 OSS</el-radio>
          </el-radio-group>
        </el-form-item>

        <template v-if="form.type === 'local'">
          <el-form-item label="本地访问前缀">
            <el-input 
              v-model="form.localUrlPrefix" 
              placeholder="例如: http://localhost:8080 或留空使用相对路径"
            />
            <div style="color: #909399; font-size: 12px; margin-top: 5px;">
              留空时使用相对路径 /uploads/，填写时会拼接为完整 URL
            </div>
          </el-form-item>
        </template>

        <template v-if="form.type === 'oss'">
          <el-form-item label="Endpoint" required>
            <el-input 
              v-model="form.endpoint" 
              placeholder="例如: oss-cn-hangzhou.aliyuncs.com"
            />
          </el-form-item>

          <el-form-item label="Bucket 名称" required>
            <el-input 
              v-model="form.bucketName" 
              placeholder="例如: my-bucket"
            />
          </el-form-item>

          <el-form-item label="访问域名">
            <el-input 
              v-model="form.domain" 
              placeholder="自定义域名，留空使用默认域名"
            />
            <div style="color: #909399; font-size: 12px; margin-top: 5px;">
              留空时自动生成：https://bucket.endpoint
            </div>
          </el-form-item>

          <el-form-item label="上传根目录">
            <el-input 
              v-model="form.basePath" 
              placeholder="例如: uploads 或留空"
            />
            <div style="color: #909399; font-size: 12px; margin-top: 5px;">
              OSS 中的文件路径前缀，留空则直接存储在 Bucket 根目录
            </div>
          </el-form-item>

          <el-form-item label="AccessKey ID" required>
            <el-input 
              v-model="form.accessKeyId" 
              :placeholder="form.hasAccessKeyId ? '已设置，留空不修改' : '请输入 AccessKey ID'"
              show-password
            />
          </el-form-item>

          <el-form-item label="AccessKey Secret" required>
            <el-input 
              v-model="form.accessKeySecret" 
              :placeholder="form.hasAccessKeySecret ? '已设置，留空不修改' : '请输入 AccessKey Secret'"
              show-password
            />
          </el-form-item>
        </template>

        <el-form-item>
          <el-button type="primary" @click="handleSave" :loading="saving">
            保存配置
          </el-button>
          <el-button @click="handleReset">重置</el-button>
        </el-form-item>
      </el-form>
    </el-card>
  </div>
</template>

<script>
import request from '@/utils/request'

export default {
  data () {
    return {
      form: {
        type: 'local',
        localUrlPrefix: '',
        endpoint: '',
        bucketName: '',
        domain: '',
        basePath: '',
        accessKeyId: '',
        accessKeySecret: '',
        hasAccessKeyId: false,
        hasAccessKeySecret: false
      },
      originalForm: null,
      saving: false
    }
  },
  mounted () {
    this.loadConfig()
  },
  methods: {
    async loadConfig () {
      try {
        const res = await request.get('/admin/configs/oss')
        this.form = {
          type: res.data.type || 'local',
          localUrlPrefix: res.data.localUrlPrefix || '',
          endpoint: res.data.endpoint || '',
          bucketName: res.data.bucketName || '',
          domain: res.data.domain || '',
          basePath: res.data.basePath || '',
          accessKeyId: res.data.accessKeyId || '',
          accessKeySecret: res.data.accessKeySecret || '',
          hasAccessKeyId: res.data.hasAccessKeyId || false,
          hasAccessKeySecret: res.data.hasAccessKeySecret || false
        }
        this.originalForm = JSON.parse(JSON.stringify(this.form))
      } catch (error) {
        this.$message.error('加载配置失败：' + error.message)
      }
    },
    async handleSave () {
      if (this.form.type === 'oss') {
        if (!this.form.endpoint) {
          this.$message.warning('请填写 Endpoint')
          return
        }
        if (!this.form.bucketName) {
          this.$message.warning('请填写 Bucket 名称')
          return
        }
        if (!this.form.hasAccessKeyId && !this.form.accessKeyId) {
          this.$message.warning('请填写 AccessKey ID')
          return
        }
        if (!this.form.hasAccessKeySecret && !this.form.accessKeySecret) {
          this.$message.warning('请填写 AccessKey Secret')
          return
        }
      }

      this.saving = true
      try {
        await request.put('/admin/configs/oss', {
          type: this.form.type,
          localUrlPrefix: this.form.localUrlPrefix,
          endpoint: this.form.endpoint,
          bucketName: this.form.bucketName,
          domain: this.form.domain,
          basePath: this.form.basePath,
          accessKeyId: this.form.accessKeyId,
          accessKeySecret: this.form.accessKeySecret
        })
        this.$message.success('保存成功')
        await this.loadConfig()
      } catch (error) {
        this.$message.error('保存失败：' + error.message)
      } finally {
        this.saving = false
      }
    },
    handleReset () {
      if (this.originalForm) {
        this.form = JSON.parse(JSON.stringify(this.originalForm))
      }
    }
  }
}
</script>
